import React, { Children, Component } from "react"
import { getBellringerQuestionForReview, getBellringerQuestionMetaData, getBellringerSetNumber, getBellringersImageURL } from "../../services/bellringers"
import { MathKatex2 } from "../../components/MathKatex"
import { Context, Resource, sendUserActivity, UserActivityEx } from "../../services/liveview/liveview-service"
import { SimpleTimer } from "../../services/utils/simple-timer"
import { CDN_PUB_URL_BELLRINGERS } from "../../constants"

interface Props {
    bellringerId: string
    onClose?: () => void
}

interface State {
    bellringer?
}

export class BellringerQuestionReview extends React.Component<Props, State> {
    simpleTimer = new SimpleTimer()

    constructor(props) {
        super(props)
        this.state = {}
    }

    async componentDidMount() {
        let {bellringerId} = this.props
        let bellringer = await getBellringerQuestionForReview(bellringerId)
        this.setState({bellringer})
    }

    componentWillUnmount(): void {
        this.sendStats()
    }

    sendStats() {
        let {bellringerId} = this.props
        let {subject} = getBellringerQuestionMetaData(bellringerId)
        let seconds = this.simpleTimer.diffInSeconds()
        let ended = seconds
        let context = Context.BELLRINGER
        let contextId = "BellringersReview"
        let category = subject
        let resource = Resource.REVIEW
        let resourceId = bellringerId
        let userActivityEx: UserActivityEx = {
            context, contextId, 
            resource, resourceId, 
            category,
            ended
        }
        sendUserActivity(userActivityEx, true)
        this.simpleTimer.reset()
    }

    render() {
        let {bellringerId, onClose} = this.props
        let {bellringer} = this.state

        if (!bellringer) return null

        // All the bellringer question info including student's answer
        let {subject, grade, week, questionNo, questionText, questionImage, questionQualifier,
            correctAnswer, 
            optionA, optionB, optionC, optionD,
            explanationA, explanationB, explanationC, explanationD,
            userSubmittedAnswer, bookmarked, correct
        } = bellringer
        let bellringersImage = getBellringersImageURL(questionImage)
        let alt = `Image of ${bellringerId}`
        let options = {optionA, optionB, optionC, optionD}
        let setNo = getBellringerSetNumber(grade)
        let title = `${subject} Set: ${setNo} Week: ${week} Question: ${questionNo}`

        return (
            <div className="bellringer-question-review-container" style={{maxWidth : "1290px", margin: "0 auto"}}>
                <div className="modal-header">
                    <h2 className="mb-0">{title}</h2>
                    <button type="button" className="modal-close" title="Close Modal" aria-label="Close" onClick={onClose}>
                        <img
                            alt=""
                            className="modal-icon"
                            src={`/assets/images/icons/v2/ico-modal-close.svg`}
                            width="24"
                            height="24"
                        />
                    </button>
                </div>
                <div className="bellringers-modal--content">
                    <div className="bellringers-modal--question-summary">
                        <div className=""><MathKatex2 mixedContent={questionText}/></div>
                        <div className="bellringers-modal--question">
                            {questionImage && <img src={bellringersImage} alt={alt} />}
                        </div>
                    </div>
                    <div className="bellringers-modal--qualify mb-3">
                        <b><MathKatex2 mixedContent={questionQualifier}/></b>
                    </div>
                    <div className="bellringers-modal--options mb-3 question-explanation-sat">
                        <AnswersReviewGroup
                            options={options}
                            correctAnswer={correctAnswer}
                            userSubmittedAnswer={userSubmittedAnswer}
                        />
                    </div>
                    <div className="">
                        <div className="bellringers-modal--answers">
                            <div className="answer-choice-wrapper">
                                <b>Your answer is {userSubmittedAnswer}. The correct answer is {correctAnswer}.</b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

// Just for review, no answer selection is allowed!
function AnswersReviewGroup(props) {
    let {options, correctAnswer, userSubmittedAnswer} = props
    let {optionA, optionB, optionC, optionD} = options

    let answers = [
        {value: "A", content: optionA},
        {value: "B", content: optionB},
        {value: "C", content: optionC},
        {value: "D", content: optionD},
    ]

    return (
        <div className="bellringers-review-answers-container answers-group">
            {answers.map(answer => {
                let {value, content} = answer
                let isCorrect = value === correctAnswer
                let isSelected = value === userSubmittedAnswer

                let statusClass = ""

                if (isCorrect && isSelected) {
                    statusClass = "answer-choice--correct-and-selected"
                }
                else if (isCorrect) {
                    statusClass = "answer-choice--correct"
                }
                else if (isSelected) {
                    statusClass = "answer-choice--selected"
                }

                let className = `answer-choice ${statusClass}`.trim()

                if (content && content.includes("$CDN")) {
                    let url = content.replace("$CDN", CDN_PUB_URL_BELLRINGERS)
                    content = `<img src=${url} class="review-image" alt="review image"/>`
                }

                return (
                    <div className="answer-choice-wrapper" key={value}>
                        <div className={className}>
                            <span className="answer-choice--value">{value}</span>
                            &nbsp;
                            <span className="">
                                <MathKatex2 mixedContent={content}/>
                            </span>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}